import type {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import type { Observable } from 'rxjs';
import type { OnboardingSetupComponent } from './onboarding-setup.component';

/**
 * `canDeactivate` for the onboarding wizard (EDUS-2690 / AC-11.1).
 *
 * A named function rather than an inline lambda in `app.routes.ts`, for the same
 * reason {@link resolvePostAuthTarget} is a free function: nothing can import
 * `app.routes.ts` under Vitest — it reaches `authGuard` → the authentication
 * service → rxfire, whose ESM the runner cannot resolve. An inline lambda was
 * therefore untestable, and the one thing worth testing here is easy to get
 * silently wrong: it must forward `nextState.url`, a STRING. Passing `nextState`
 * compiles, and `canLeaveWizard` then calls `.startsWith()` on an object, which
 * is `undefined` — so the `/login-status` exemption would quietly stop working
 * and admins force-routed out of a dead session would be prompted on the way.
 *
 * Every import here is `import type`, so this module stays free of runtime
 * dependencies and the route keeps its lazy chunk.
 */
export function canLeaveOnboardingWizard(
  component: OnboardingSetupComponent,
  _currentRoute: ActivatedRouteSnapshot,
  _currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot
): Observable<boolean> {
  return component.canLeaveWizard(nextState.url);
}
